import {getQuery} from "@/modules/common/utils";
import {httpService} from "@/modules/common/services";

const REPORTS_PATH = 'analytics/reports';

const getReports = async (businessId) => {
  let result;
  try {
    result = await httpService.get('business/reports',{business_id: businessId});
    return {status : 'OK', report: result.data}
  } catch (error) {
    return {status : 'ERROR', data: error};
  }
}

const formatDates = (startDate, endDate) => {
  let date = {}
  date['day2'] = endDate.format('D')
  date['month2'] = endDate.format('MMM')
  date['year2'] = endDate.format('YYYY')
  date['day1'] = startDate.format('D');
  date['month1'] = startDate.format('MMM')
  date['year1'] = startDate.format('YYYY')
  let dateRange = {startDay: date['day1'], startMonth: date['month1'], startYear: date['year1'], endDay: date['day2'], endMonth: date['month2'], endYear: date['year2']}
  return dateRange;
}

const buildFilterMessageForLooker = (data, filtersConfig) => {
  let filterMessage = [];
  Object.keys(data).forEach(currentFilter => {
    let currentFilterObject = {};
    currentFilterObject.viewName = filtersConfig.view_name
    switch(currentFilter){
      case "dateRange":{
        if(data.datesInterval === "" && data.dateRange[0] !== "" && data.dateRange[1] !== ""){
          currentFilterObject.fieldName = filtersConfig.date.field
          currentFilterObject.value = buildDatesRangeFilterValue(data.dateRange)
          filterMessage.push(currentFilterObject)
        }
        break;
      }
      case "datesInterval":{
        if(data.dateRange[0] === "" && data.dateRange[1] === "" && data.datesInterval !== ""){
          currentFilterObject.fieldName = filtersConfig.date.field
          currentFilterObject.value = buildIntervalFilterValue(data.datesInterval.value)
          filterMessage.push(currentFilterObject)
        }
        break;
      }
      case "selectedStaff":{
        if(filtersConfig.staff){
          currentFilterObject.fieldName = filtersConfig.staff.field
          currentFilterObject.value = data.selectedStaff.join(",")
          filterMessage.push(currentFilterObject)
        }
        break;
      }
      case "selectedServices": {
        if (filtersConfig.services) {
          currentFilterObject.fieldName = filtersConfig.services.field
          currentFilterObject.value = data.selectedServices.join(",")
          filterMessage.push(currentFilterObject)
        }
        break;
      }
    }
  })
  return filterMessage;
}

const buildDatesRangeFilterValue = (dateRange) => {
  return `${dateRange[0]} to ${dateRange[1]}`
}

const buildIntervalFilterValue = (value) => {
  if(!value.amount)
    return value.type
  else
    return `${value.amount} ${value.type}`
}

const isDataFiltered = (filterMessage, monthlyTimeRange) =>{
  const activeFilters = filterMessage.filter(curr => curr.value !== '')
  if(activeFilters.length === 0) return false
  else if(activeFilters.length === 1){
    if(activeFilters[0].fieldName.match(/\w*(time)|\w*(date)/gmi)){
      return (activeFilters[0].value.replace(' months','') !== monthlyTimeRange.toString())
    }
  }
  return true
}

export const reportsService = {
  getReports,
  formatDates,
  buildFilterMessageForLooker,
  isDataFiltered
}
